module.exports = __webpack_public_path__ + "static/img/red_03_514.37407cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/red_03_514.png
// module id = dTuZ
// module chunks = 0